<template>
    <div class="notifications-bar">
        <div class="notibox" v-for="(noti,index) in getNotifications.data" :key="index">
            <div style="width: 100%" v-if="noti.type === 'new_review' " @click="goToReview(noti)">
                <div class="header-stand">
                    <img src="/avatars/av2.png">
                    <p> {{ noti.type === 'user_followed' ? 'New Follower' : 'New Notification' }}</p>
                    <h1 v-if="noti.type === 'user_followed' "><router-link :to="`/profile/${noti.username}`">{{noti.username}}</router-link></h1>
                    <h1 v-else>{{ noti.username }}</h1>
                </div>
                <div class="body-stand">
                    <p v-html="noti.message"></p>
                </div>
            </div>
            <div style="width: 100%" v-else>
                <div class="header-stand">
                    <img src="/avatars/av2.png">
                    <p> {{ noti.type === 'user_followed' ? 'New Follower' : 'New Notification' }}</p>
                    <h1><router-link :to="`/profile/${noti.username}`">{{noti.username}}</router-link></h1>
                </div>
                <div class="body-stand">
                    <p v-html="noti.message"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "index",
        computed: {
            ...mapState(['notifications']),
            getNotifications() {
                return this.notifications
            },
        },
        mounted() {
            this.markAllNotifications()
        },
        methods: {
            goToReview(noti) {
                this.$router.push({ name: 'Review', params: { username: noti.username, tweet_slug: noti.slug } })
            },
            markAllNotifications() {
                const noti = this.getNotifications;
                const newNoti = {
                    data: noti.data,
                    total: 0,
                    first_page_url: noti.first_page_url,
                    last_page_url: noti.last_page_url,
                    next_page_url: noti.next_page_url,
                };
                this.$store.commit('setNotifications',newNoti)
                this.axios.get('/notifications/mark/all')
            },
        },
    }
</script>

<style scoped>
.notifications-bar {
    width: 100%;
    float: left;
}
    .notifications-bar .notibox {
        width: 100%;
        float: left;
        padding: 20px 30px;
        border-bottom: solid 1px rgba(230, 236, 245, 0.1) !important;
        cursor: pointer;
    }
    .notibox:hover {
        background-color: rgba(220, 224, 228, 0.1) !important;
    }
    .notibox .header-stand {
        width: 100%;
        float: left;
    }
    .notibox .body-stand {
        width: 100%;
        float: left;
        padding-top: 20px;
    }
    .header-stand img {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        float: left;
        margin-right: 10px;
    }
    .header-stand p {
        color: #dddfec;
        font-size: 14px;
        margin: 0;
    }
.header-stand h1 {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
}
    .body-stand p {
        color: #c5c7d8;
        font-size: 14px;
        margin: 0;
    }
</style>